<template>
  <el-dialog
    title="Create Coupon"
    :visible="dialog"
    width="500px"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <el-form ref="couponForm" :model="form" :rules="rules" label-position="top">
      <el-form-item label="Campaign Name" prop="campaign_name">
        <el-input v-model="form.campaign_name" placeholder="Enter campaign name" clearable
        ></el-input>
      </el-form-item>

      <el-form-item label="Recipient Email" prop="recipient_email">
        <el-input v-model="form.recipient_email" placeholder="Enter recipient email" type="email" clearable
        ></el-input>
      </el-form-item>

      <el-form-item label="Value" prop="value">
        <el-input-number v-model="form.value" :min="0.01" :precision="2" :step="1" placeholder="Enter value" class="w100"
        ></el-input-number>
      </el-form-item>

      <el-form-item label="Currency Type" prop="currency_type">
        <el-select v-model="form.currency_type" placeholder="Select currency" class="w100">
          <el-option label="USDT" value="USDT"></el-option>
          <el-option label="SVTS" value="SVTS"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="Expiration Date" prop="expires_at">
        <el-date-picker v-model="form.expires_at" type="date" placeholder="Select expiration date" format="yyyy-MM-dd"
          value-format="yyyy-MM-dd" :picker-options="datePickerOptions" class="w100"
        ></el-date-picker>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">Cancel</el-button>
      <el-button type="primary" :loading="loading" @click="handleSubmit">
        Create Coupon
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  data() {
    return {
      form: {
        campaign_name: '',
        recipient_email: '',
        value: null,
        currency_type: 'USDT',
        expires_at: ''
      },
      rules: {
        campaign_name: [
          { required: true, message: 'Campaign name is required', trigger: 'blur' }
        ],
        recipient_email: [
          { required: true, message: 'Recipient email is required', trigger: 'blur' },
          { type: 'email', message: 'Please enter a valid email address', trigger: 'blur' }
        ],
        value: [
          { required: true, message: 'Value is required', trigger: 'blur' }
        ],
        currency_type: [
          { required: true, message: 'Currency type is required', trigger: 'change' }
        ],
        expires_at: [
          { required: true, message: 'Expiration date is required', trigger: 'change' }
        ]
      },
      datePickerOptions: {
        disabledDate(date) {
          return date < new Date()
        }
      },
      loading: false
    }
  },

  computed: {
    ...mapState('coupons', ['dialog'])
  },

  methods: {
    ...mapActions('coupons', ['create']),
    ...mapMutations('coupons', ['setDialog']),

    handleClose() {
      this.resetForm()
      this.setDialog(false)
    },

    resetForm() {
      this.form = {
        campaign_name: '',
        recipient_email: '',
        value: null,
        currency_type: 'USDT',
        expires_at: ''
      }
      if (this.$refs.couponForm) this.$refs.couponForm.resetFields()
    },

    handleSubmit() {
      this.$refs.couponForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.create(this.form)
            .then(() => { this.handleClose() })
            .finally(() => { this.loading = false })
        }
      })
    }
  }
}
</script>

<style scoped>
.w100 {
  width: 100%;
}
</style>
